import React, { Component, memo } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { ButtonGroup, FormControl, InputLabel, OutlinedInput, Select } from '@mui/material';
import { withStyles } from '@mui/styles'
import { withRouter } from "common/utils/router.util";
import validate from 'validate.js';
import {
    Grid,
    TextField,
    Button,
    Typography,
    LinearProgress,
    MenuItem
} from '@mui/material';
import { Portlet, PortletContent, PortletFooter } from 'components';
import styles from './styles';
import PropTypes from 'prop-types';
import { SearchAgentByStatusAPI } from 'services/agent';
import { showErrorNotification } from 'common/helpers';
import { withSnackbar } from 'notistack';
import { compose } from 'recompose';
import Base from 'common/constants';
import { GetStateStorage } from 'common/storage';
import { getDefaultStateID } from 'common/helpers';
import { getDefaultCountyID } from 'common/helpers';
import { RemoveCookieItem, SetCookieItem } from 'common/cookies';
import { GetCookieItem } from 'common/cookies';
import { showInfoNotification } from 'common/helpers';
import { getAllMarketsData, getAllSchedulesV1 } from 'views/AgentPmaSchedulesV1/AgentPmaScheduleServices';

class AgentSearchForm extends Component {
    static hasInitialized = false; // Static property to track initialization across instances

    constructor(props) {
        super(props);
        this.state = this.getInitialState();
        this.hasInitialized = false; // Instance property to track initialization
        this.lastFormDataKey = null; // Memoization for form data
    }

    getInitialState() {
        return {
            values: {
                status: 'active',
                selectedState: '',
                selectedCounty: '',
                filterChoice: 'county',
                selectedSchedule: '',
                selectedMarket: '-'
            },
            stateLabelRef: null,
            countyLabelRef: null,
            disableStateCountyDropdowns: false,
            countyData: Base.COUNTY_ID_NAME_MAP,
            stateData: {
                "1": 'California'
            },

            allAgentData: [],
            scheduleData: [],
            marketMapData: [],
            scheduleMarketData: []
        };
    };

    componentDidMount() {
            this.setState(prevState => (this.getStateCountyInitialData(prevState)), () => {
                this.getAllSchedulesFn();
                this.getAllMarketsFn();
                this.applyFilters();
            });
    };

    componentWillUnmount() {
        console.log('AgentSearchForm:componentWillUnmount fired at:', new Date().toISOString());
    }

    componentDidUpdate(prevProps, prevState) {
        // Clear invalid selectedSchedule when scheduleData changes
        if (prevState.scheduleData !== this.state.scheduleData && this.state.scheduleData.length > 0) {
            const isValidSchedule = this.state.scheduleData.some(s => s.pmaScheduleID === this.state.values.selectedSchedule);
            if (!isValidSchedule && this.state.values.selectedSchedule) {
                this.setState(prevState => ({
                    values: {
                        ...prevState.values,
                        selectedSchedule: ''
                    }
                }));
            }
        }
    }


    //we going to need this data on load of component and in reset filter also
    getStateCountyInitialData = (prevState) => {
        //here no need to check session switch it used in admin side only
        const { userData } = GetStateStorage();
        let stateID = GetCookieItem(Base.CookieStorageBase.LG_DEFAULT_SELECTED_STATE_ID);
        let countyID = GetCookieItem(Base.CookieStorageBase.LG_DEFAULT_SELECTED_COUNTY_ID);
        let scheduleID = GetCookieItem(Base.CookieStorageBase.LG_DEFAULT_SELECTED_SCHEDULE_ID);
        let marketID = GetCookieItem(Base.CookieStorageBase.LG_DEFAULT_SELECTED_SCHEDULE_MARKET_ID);
        //We use this component in mailpro insight and agent schedule screen. In mailpro insight apis we have support for market but for other screen we dont have so we need to disable market option as per disableFilterChoice. Also, if disableFilterChoice is true and we dont have county cookie set than we will use default ones. But for mailpro insight we dont use default option because in that at a time we can have one option either county or market.
        const finalFilterChoice = this.props.disableFilterChoice ? 'county' : (scheduleID ? 'market' : 'county');
        let selectedState = '', selectedCounty = '';

        selectedState = (stateID ? stateID : this.props.disableFilterChoice ? getDefaultStateID(userData.listgenRoleID, userData.listgenUserID) : '');
        selectedCounty = (countyID ? countyID : this.props.disableFilterChoice ? getDefaultCountyID(userData.listgenRoleID, userData.listgenUserID) : '');
        // normalize legacy cookie values
        if (marketID === 'DEFAULT') {
            marketID = '';
        }

        return {
            disableStateCountyDropdowns: false,
            values: {
                ...prevState.values, ...{
                    selectedState: selectedState,
                    selectedCounty: selectedCounty,
                    selectedSchedule: (scheduleID ? scheduleID : ''),
                    selectedMarket: (marketID && marketID !== 'DEFAULT' ? marketID : ''),
                    filterChoice: finalFilterChoice
                }
            }
        };
    };

    resetFormValues() {
        let initialState = this.getInitialState();
        this.setState(prevState => ({
            ...initialState,
            ...this.getStateCountyInitialData(initialState)
        }), () => {
            this.applyFilters();
        });
    }

    handleFieldChange = (field, value, event) => {
        const newState = { ...this.state };
        newState.values[field] = value;

        if (field === 'filterChoice') {
            newState.values.selectedCounty = '';
            newState.values.selectedSchedule = '';
            newState.values.selectedMarket = '';
            //ToDo: Once we have moved all data to V1 than remove below market code and v0&v1 code as well
            this.getAllSchedulesFn();
        }

        if (field === 'selectedSchedule') {
            newState.values.selectedMarket = '-';
        }

        this.setState(newState, () => {
            if (field === 'selectedCounty' || field === 'selectedSchedule' || field === 'selectedMarket') {
                this.applyFilters();
            }
            if (field === 'selectedSchedule') {
                this.setState(prevState => ({
                    ...prevState,
                    scheduleMarketData: this.getMarketDataByScheduleID(value)
                }));
            }
            if (field === 'filterChoice') {
                RemoveCookieItem(Base.CookieStorageBase.LG_DEFAULT_SELECTED_SCHEDULE_ID);
                RemoveCookieItem(Base.CookieStorageBase.LG_DEFAULT_SELECTED_SCHEDULE_MARKET_ID);
                RemoveCookieItem(Base.CookieStorageBase.LG_DEFAULT_SELECTED_COUNTY_ID);
                this.callParentCallbackFn([], this.state.values);

            }
        });
    };

    applyFilters = async () => {
        this.filterUsers(this.state.values);
    };

    callParentCallbackFn = (agentData, formData) => {
        const { setFilteredAgentData } = this.props;
        const scheduleDisplayName = this.getScheduleDisplayName(formData.selectedSchedule);
        const scheduleMarketDisplayName = this.getMarketDisplayName(formData.selectedMarket);
        setFilteredAgentData(agentData, false, this.state.stateData[this.state.values.selectedState] || '', this.state.countyData[this.state.values.selectedCounty] || '', this.state.values.selectedState, this.state.values.selectedCounty, this.state.values.status, this.state.values.filterChoice, this.state.values.selectedSchedule, scheduleDisplayName, this.state.values.selectedMarket, scheduleMarketDisplayName);
    }

    filterUsers(formData) {
        /**set to loading state */
        const { setFilteredAgentData, startLoading, defaultLoadAgents } = this.props;
        
        // Memoize the form data to prevent duplicate API calls
        const formDataKey = JSON.stringify({
            selectedCounty: formData.selectedCounty,
            status: formData.status,
            filterChoice: formData.filterChoice,
            selectedSchedule: formData.selectedSchedule,
            selectedMarket: formData.selectedMarket
        });
        
        if (this.lastFormDataKey === formDataKey) {
            return; // Skip if same data was already processed
        }
        this.lastFormDataKey = formDataKey;
        
        //we dont to load agents from here so call setFilteredAgentData
        if (!defaultLoadAgents) {
            this.callParentCallbackFn([], formData);
            return;
        }
        startLoading();
        SearchAgentByStatusAPI(formData.selectedCounty, formData.status, formData.filterChoice, formData.selectedSchedule, formData.selectedMarket).then(data => {
            //resolve(data);
            if (data.length > 0) {
                this.setState((prevState, prevPros) => ({
                    allAgentData: data,
                }));
                this.callParentCallbackFn(data, formData);
            } else {
                showInfoNotification(this.props, "No agents found.");
                setFilteredAgentData([], false);
            }
        })
            .catch(err => {
                //reject(err);
                console.log('error', err);
                showErrorNotification(this.props, "Unable to process request.");
                setFilteredAgentData([], false);
            }).finally(() => {

                if (formData.filterChoice === 'county') {
                    this.setCountyCookie(formData.selectedCounty);
                } else if (formData.filterChoice === 'market') {
                    this.setScheduleCookie(formData.selectedSchedule);
                    formData.selectedMarket && this.setMarketCookie(formData.selectedMarket);
                }

            }
            );
    };

    getScheduleDisplayName = (scheduleID) => {
        if (!scheduleID || this.state.scheduleData.length === 0) {
            return "";
        }
        return (this.state.scheduleData.find(schedule => schedule.pmaScheduleID === scheduleID) || {}).displayPMAScheduleID;
    }

    getMarketDisplayName = (marketID) => {
        if (!marketID || this.state.marketMapData.length === 0) {
            return "";
        }
        return (this.state.marketMapData.find(market => market.pmaMarketID === marketID) || {}).displayPMAMarketID;
    }

    getAllSchedulesFn = () => {
        let apiFn = getAllSchedulesV1;
        apiFn().then(data => {
            this.setState(prevState => ({
                ...prevState,
                scheduleData: data
            }), () => {
                this.state.values.selectedSchedule && this.setState(prevState => ({
                    ...prevState,
                    scheduleMarketData: this.getMarketDataByScheduleID(this.state.values.selectedSchedule)
                }));
            });

        }
        ).catch(err => {
            showErrorNotification(this.props, "Unable to get schedules.");
        });
    }

    getAllMarketsFn = () => {
        getAllMarketsData().then(data => {
            this.setState(prevState => ({
                ...prevState,
                marketMapData: data
            }));
        }
        ).catch(err => {
            showErrorNotification(this.props, "Unable to get markets.");
        });
    }

    getMarketDataByScheduleID = (scheduleID) => {
        const marketData = this.state.marketMapData.find(market => market.pmaScheduleID === scheduleID);
        return marketData && marketData.pmaMarkets ? marketData.pmaMarkets : [];
    }

    setCountyCookie = (countyID) => {
        SetCookieItem(Base.CookieStorageBase.LG_DEFAULT_SELECTED_COUNTY_ID, countyID, 2628000, "/", null, false);
    }

    setScheduleCookie = (scheduleID) => {
        SetCookieItem(Base.CookieStorageBase.LG_DEFAULT_SELECTED_SCHEDULE_ID, scheduleID, 2628000, "/", null, false);
    }

    setMarketCookie = (marketID) => {
        SetCookieItem(Base.CookieStorageBase.LG_DEFAULT_SELECTED_SCHEDULE_MARKET_ID, marketID, 2628000, "/", null, false);
    }

    render() {
        const { classes, className, isLoading, statusData, disableFilterChoice } = this.props;
        const rootClassName = classNames(classes.root, className);
        const {
            values,
            stateData,
            countyData,
            allAgentData,
            scheduleData,
            scheduleMarketData
        } = this.state;

        // console.log('render ------------------', this.state);

        const { filterChoice } = values;

        return (
            <Portlet className={rootClassName} outlined={true} noPaper>

                <PortletContent noPadding>
                    <form
                        autoComplete="off"
                        noValidate
                    >

                        <Grid container className={classes.grid} spacing={0}>
                            <Grid item lg={3}>
                                <div className={classes.filterChoiceContainer}>
                                    <Typography variant='subtitle2' className={classes.filterChoiceLabel}>
                                        How do you want to filter Agents?
                                    </Typography>
                                    <ButtonGroup size="small" disabled={disableFilterChoice} className={classes.filterChoiceButtons}>
                                        <Button variant='contained' color={filterChoice === 'county' ? 'primary' : 'inherit'} onClick={event => this.handleFieldChange("filterChoice", "county", event)}>By County</Button>
                                        <Button variant='contained' color={filterChoice === 'market' ? 'primary' : 'inherit'} onClick={event => this.handleFieldChange("filterChoice", "market", event)}>By Market</Button>
                                    </ButtonGroup>
                                </div>
                            </Grid>
                            <Grid item lg={2}>
                                <div className={classes.field}>
                                    <TextField
                                        className={classNames(classes.textField)}
                                        label="Select State"
                                        margin="dense"
                                        size="small"
                                        select
                                        SelectProps={{ native: false }}
                                        InputLabelProps={{ shrink: true }}
                                        name="selectedState"
                                        value={this.state.values.selectedState}
                                        onChange={event => {
                                            this.handleFieldChange("selectedState", event.target.value, event);
                                            SetCookieItem(Base.CookieStorageBase.LG_DEFAULT_SELECTED_STATE_ID, event.target.value, 2628000, "/", null, false);
                                        }}
                                        variant="outlined"
                                        disabled={this.state.disableStateCountyDropdowns}
                                    >
                                        {/* <MenuItem key="agent-search-state-form-blank-value" value="">
                                            <em>View All States</em>
                                        </MenuItem> */}
                                        {Object.keys(stateData).map((key) => (
                                            <MenuItem key={key} value={key}>
                                                {stateData[key]}&nbsp;({key})
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                </div>
                            </Grid>
                            {filterChoice === 'county' && <Grid item lg={3}>
                                <div className={classes.field}>
                                    <FormControl className={classes.textField} variant='outlined' disabled={this.state.disableStateCountyDropdowns || filterChoice === 'market'} margin='dense' size='small'>
                                        <InputLabel id="select-county-filter-label">Select County</InputLabel>
                                        <Select
                                            labelId="select-county-filter-label"
                                            label="Select County"
                                            name="selectedCounty"
                                            value={this.state.values.selectedCounty}
                                            onChange={event => {
                                                this.handleFieldChange("selectedCounty", event.target.value, event);
                                                RemoveCookieItem(Base.CookieStorageBase.LG_DEFAULT_SELECTED_SCHEDULE_ID);
                                                RemoveCookieItem(Base.CookieStorageBase.LG_DEFAULT_SELECTED_SCHEDULE_MARKET_ID);
                                            }}
                                        >
                                            {Object.keys(countyData).map((key) => (
                                                <MenuItem key={key} value={key}>
                                                    {countyData[key]}&nbsp;({key})
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </div>
                            </Grid>}

                            <Grid item lg={filterChoice === 'market' ? 3 : 2}>
                                <div className={classes.field}>
                                    <FormControl className={classes.textField} variant='outlined' disabled={filterChoice === 'county' || disableFilterChoice} margin='dense' size='small'>
                                        <InputLabel id="select-schedule-filter-label">Select Schedule</InputLabel>
                                        <Select
                                            labelId="select-schedule-filter-label"
                                            label="Select Schedule"
                                            name="selectedSchedule"
                                            value={this.state.scheduleData.length > 0 && this.state.scheduleData.some(s => s.pmaScheduleID === this.state.values.selectedSchedule) ? this.state.values.selectedSchedule : ''}
                                            onChange={event => {
                                                this.handleFieldChange("selectedSchedule", event.target.value, event);
                                                RemoveCookieItem(Base.CookieStorageBase.LG_DEFAULT_SELECTED_COUNTY_ID);
                                            }}
                                        >
                                            {scheduleData.map((schedule) => (
                                                <MenuItem key={schedule.displayPMAScheduleID} value={schedule.pmaScheduleID}>
                                                    <div>
                                                        <p style={{ fontWeight: 500 }}>{schedule.displayPMAScheduleID}</p>
                                                        <p style={{ fontSize: '10px' }}>{schedule.pmaScheduleDesc}</p>
                                                    </div>
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </div>
                            </Grid>
                            <Grid item lg={filterChoice === 'market' ? 3 : 2}>
                                <div className={classes.field}>
                                    <FormControl className={classes.textField} variant='outlined' disabled={filterChoice === 'county' || disableFilterChoice || !this.state.values.selectedSchedule} margin='dense' size='small'>
                                        <InputLabel id="select-market-filter-label">Select Market</InputLabel>
                                        <Select
                                            labelId="select-market-filter-label"
                                            label="Select Market"
                                            name="selectedMarket"
                                            value={this.state.scheduleMarketData.length > 0 && this.state.scheduleMarketData.some(m => m.pmaMarketID === this.state.values.selectedMarket) ? this.state.values.selectedMarket : '-'}
                                            onChange={event => {
                                                this.handleFieldChange("selectedMarket", event.target.value, event);
                                                RemoveCookieItem(Base.CookieStorageBase.LG_DEFAULT_SELECTED_COUNTY_ID);
                                            }}
                                        >
                                            <MenuItem key={'all-market-schedule'} value={'-'}>All Markets</MenuItem>
                                            {scheduleMarketData.map((market) => (
                                                <MenuItem key={market.displayPMAMarketID} value={market.pmaMarketID}>
                                                    <div>
                                                        <p style={{ fontWeight: 500 }}>{market.displayPMAMarketID}</p>
                                                        <p style={{ fontSize: '10px' }}>{market.pmaMarketDesc}</p>
                                                    </div>
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </div>
                            </Grid>
                        </Grid>
                        {/* <Grid container className={classes.grid} spacing={0}><Grid item lg={4}>
                            <div className={classes.field}>
                                <TextField
                                    className={classNames(classes.textField)}
                                    label="Agent Status"
                                    helperText="Which status agent you want to search. Select here."
                                    margin="dense"
                                    select
                                    SelectProps={{ native: false }}
                                    name="status"
                                    value={this.state.values.status}
                                    onChange={event =>
                                        this.handleFieldChange("status", event.target.value, event)
                                    }
                                    variant="outlined">
                                    {statusData.map(option => (
                                        <MenuItem key={option.value} value={option.value}>
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </div>
                        </Grid>
                            <Grid item lg={4}>

                            </Grid>
                            <Grid item lg={4}></Grid>
                        </Grid> */}
                    </form>
                </PortletContent>
                <PortletFooter className={classes.portletFooter}>
                    <div className={classes.footerButtons}>
                        <div className={classes.footerButtonsLeftRight}>
                            <Button
                                variant="outlined"
                                color='default'
                                onClick={() => this.resetFormValues()}
                            >
                                Clear Search
                            </Button>
                        </div>
                        <div className={classes.footerButtonsCenter}>
                            <Button
                                color="primary"
                                variant="contained"
                                disabled={isLoading || (!values.selectedCounty && !values.selectedSchedule)}
                                onClick={event => this.filterUsers(this.state.values)}
                            >
                                Search Agent
                            </Button>
                        </div>
                        <div className={classes.footerButtonsLeftRight}></div>
                    </div>
                </PortletFooter>
            </Portlet>
        );
    }
}

AgentSearchForm.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    setFilteredAgentData: PropTypes.func.isRequired,
    startLoading: PropTypes.func.isRequired,
    defaultLoadAgents: PropTypes.bool
};

// React 19: avoid defaultProps on function components; here it's a class component.
// Keep defaults via static class field for forward compatibility.
AgentSearchForm.defaultProps = {
    isLoading: false,
    startLoading: () => { },
    defaultLoadAgents: true
};

const MemoizedAgentSearchForm = memo(AgentSearchForm);

export default compose(
    withSnackbar,
    withStyles(styles)
)(MemoizedAgentSearchForm);